var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, DateInput as RADateInput, minValue as RAminValue } from 'react-admin';
import { Box, Grid, Button, CircularProgress } from '@mui/material';
import { filter } from '../utils/componentWizard';
import SearchIcon from '@mui/icons-material/Search';
var Spacer = function () { return _jsx(Box, { mb: 1, children: "\u00A0" }); };
var FilterList = function (_a) {
    // useEffect(() => {
    //     console.log(" ")
    // }, [filters])
    var _b;
    var search = _a.search, isLoading = _a.isLoading, filters = _a.filters, setFilters = _a.setFilters, params = _a.params, translate = _a.translate;
    var SubjectsDatePicker = function (_a) {
        var filters = _a.filters, setFilters = _a.setFilters, name = _a.name, label = _a.label, minWidth = _a.minWidth, minDate = _a.minDate, maxDate = _a.maxDate, size = _a.size, notNeedRequired = _a.notNeedRequired, gridBGColor = _a.gridBGColor, width = _a.width;
        var gridStyle = {};
        if (gridBGColor) {
            gridStyle['backgroundColor'] = gridBGColor;
            gridStyle['padding'] = "0.6rem";
            gridStyle['borderRadius'] = "10px";
        }
        ;
        return (_jsx(Grid, { item: true, style: gridStyle, children: _jsx(Form, { children: _jsx(RADateInput, { source: label, variant: "outlined", 
                    // minDate={minDate ?? null}
                    //[back] min and max date not working
                    validate: RAminValue(new Date('2024-06-06')), 
                    // maxDate={maxDate  ?? null}
                    onChange: function (e) {
                        var newFilter = __assign({}, filters);
                        var date = new Date(e.target.value).toLocaleDateString('en-US');
                        if (date == "Invalid Date") {
                            delete newFilter[name];
                        }
                        else {
                            newFilter[name] = date;
                        }
                        setFilters(newFilter);
                        sessionStorage.setItem("".concat(window.location.pathname, "_filter"), JSON.stringify(newFilter));
                    }, sx: {
                        opacity: 0.6,
                        width: "9em",
                        '& .MuiInputBase-root': {
                            borderTopLeftRadius: '20px',
                            borderTopRightRadius: '20px',
                            boxShadow: '0px 6px 8px gray',
                            height: "2.7em",
                            fontWeight: 900,
                            fontSize: "1.1em",
                            '& input': {
                                opacity: 0.7,
                                paddingTop: '1em',
                            },
                        },
                        '& .MuiFormLabel-root': {},
                    }, defaultValue: (filters === null || filters === void 0 ? void 0 : filters[name]) ? new Date(filters[name]) : null }) }) }));
    };
    var sessonStorageJSON = (_b = JSON.parse(sessionStorage.getItem("".concat(window.location.pathname, "_filter")))) !== null && _b !== void 0 ? _b : {};
    var updatedFilters = __assign(__assign({}, filters), sessonStorageJSON);
    return (_jsxs(Grid, { container: true, spacing: 0.5, justifyContent: "start", sx: { position: 'sticky', top: 0, zIndex: 1000, backgroundColor: 'white', padding: '0px', }, children: [_jsx(SubjectsDatePicker, { filters: updatedFilters, setFilters: setFilters, label: translate("pages.subject.fields.examFromDate"), name: "examFromDate", xs: 12, md: 4, minWidth: 180, minDate: new Date(2019, 8, 1), maxDate: new Date(), notNeedRequired: true }), _jsx(SubjectsDatePicker, { filters: updatedFilters, setFilters: setFilters, label: translate("pages.subject.fields.examToDate"), name: "examToDate", xs: 12, md: 4, minWidth: 180, minDate: new Date(2019, 8, 1), maxDate: new Date(), notNeedRequired: true }), _jsx(filter.textField, { filters: filters, setFilters: setFilters, label: translate("pages.subject.fields.id"), name: "id" }), _jsx(filter.textField, { filters: filters, setFilters: setFilters, label: translate("pages.subject.fields.lastname"), name: "lastname" }), _jsx(filter.textField, { filters: filters, setFilters: setFilters, label: translate("pages.subject.fields.firstname"), name: "firstname" }), _jsx(filter.dropDownList, { filters: filters, setFilters: setFilters, label: translate("pages.subject.fields.gender"), name: "gender", minWidth: 120, options: params }), _jsx(filter.dropDownList, { filters: filters, setFilters: setFilters, label: translate("pages.subject.fields.educationLevel"), name: "educationLevel", minWidth: 160, options: params }), _jsx(SubjectsDatePicker, { filters: updatedFilters, setFilters: setFilters, label: translate("pages.subject.fields.analyzeFromDate"), name: "analyzeFromDate", xs: 12, md: 4, minWidth: 180, minDate: new Date(2019, 8, 1), maxDate: new Date(), notNeedRequired: true }), _jsx(SubjectsDatePicker, { filters: updatedFilters, setFilters: setFilters, label: translate("pages.subject.fields.analyzeToDate"), name: "analyzeToDate", xs: 12, md: 4, minWidth: 180, minDate: new Date(2019, 8, 1), maxDate: new Date(), notNeedRequired: true }), _jsx(Grid, { item: true, alignItems: "end", justifyContent: "end", children: _jsx(Button, { variant: "contained", disabled: isLoading, onClick: function () { search(); }, color: "common", startIcon: _jsx(SearchIcon, { sx: {
                            animation: 'pulse 2s infinite ease-in-out',
                            '@keyframes pulse': {
                                '0%': {
                                    transform: 'scale(1)',
                                },
                                '50%': {
                                    transform: 'scale(1.5)',
                                },
                                '100%': {
                                    transform: 'scale(1)',
                                },
                            },
                        } }), sx: {
                        marginTop: "0.5em",
                        height: "3.5em",
                        width: "9em",
                        fontWeight: "900",
                        color: "#0d47a1",
                        borderRadius: '20px',
                        boxShadow: '0px 6px 8px gray',
                        opacity: "0.6",
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                            backgroundColor: '#1976d2',
                            color: 'white',
                            transform: 'scale(1.05)',
                            boxShadow: '0px 8px 12px rgba(0, 0, 0, 0.3)',
                            opacity: "1",
                        },
                        '&:active': {
                            transform: 'scale(0.95)',
                        },
                        '&:hover .MuiSvgIcon-root': {
                            animation: 'pulseHover 1.5s infinite ease-in-out',
                        },
                        '@keyframes pulseHover': {
                            '0%': {
                                transform: 'scale(1)',
                            },
                            '50%': {
                                transform: 'scale(1.8)',
                            },
                            '100%': {
                                transform: 'scale(1)',
                            },
                        },
                    }, children: isLoading ? _jsx(CircularProgress, { size: 24 }) : 'Search' }) })] }));
};
export default FilterList;
